module.exports = __webpack_public_path__ + "static/img/fangL.d86049e5.svg";